import { render } from "./ViolationFilterView.vue?vue&type=template&id=2c714237&scoped=true"
import script from "./ViolationFilterView.vue?vue&type=script&lang=js"
export * from "./ViolationFilterView.vue?vue&type=script&lang=js"

import "./ViolationFilterView.vue?vue&type=style&index=0&id=2c714237&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c714237"]])

export default __exports__